import { render } from "./LoaderIntegrationSettings.vue?vue&type=template&id=3ca3f994"
import script from "./LoaderIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./LoaderIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__